
export class ManageJournalDTO {
    JournalId: string;
    Title: string;
    SurgeonName: string;
    SurgeonEmail:string;
    JournalProcedure: string;
    Anaesthetist: string;
    Team: string;
    Notes: string;
    StartDate:string;
    StartTime:string;
    EndDate:string;
    EndTime:string;
    Start: string;
    End: string;
}


export class JournalDTO {
    journalId: string;
    title: string;
    surgeonName: string;
    journalProcedure: string;
    anaesthetist: string;
    team: string;
    notes: string;
    start: string;
    end: string;
    className: string;
}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Models/Journal.model.ts